import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import {
  PaymentDescriptionRowStyles,
  PaymentDescriptionStyles,
} from '../PaymentDescription/PaymentDescription.styles';

const ORIGINAL_PRICES: Record<string, number> = {
  'pro.one_off_1d_9_99': 19.99,
  'pro.one_off_1d_14_99': 29.99,
  'pro.one_off_1d_19_99': 39.99,
};

export const OneOffPaymentDescription: React.FC<{
  selectedPlan: StripeV2SubscriptionPrice;
}> = ({ selectedPlan }) => {
  const originalPrice = ORIGINAL_PRICES[selectedPlan.id];
  const discount = originalPrice ? originalPrice - selectedPlan.price : 0;

  return (
    <PaymentDescriptionStyles>
      <PaymentDescriptionRowStyles>
        <UiTypography variant="body-medium">1 Day VIP</UiTypography>
        <UiTypography variant="body-medium">
          ${originalPrice || selectedPlan.price}
        </UiTypography>
      </PaymentDescriptionRowStyles>

      {discount > 0 && (
        <PaymentDescriptionRowStyles>
          <UiTypography variant="body-medium">Discount</UiTypography>
          <UiTypography variant="body-medium" color="danger">
            -${discount.toFixed(2)}
          </UiTypography>
        </PaymentDescriptionRowStyles>
      )}

      <PaymentDescriptionRowStyles>
        <UiTypography variant="title-large">Total</UiTypography>
        <UiTypography variant="title-large">${selectedPlan.price}</UiTypography>
      </PaymentDescriptionRowStyles>
    </PaymentDescriptionStyles>
  );
};
